import { FormModel } from '../../../../../components/Form';
import { Validators } from '../../../../../utils/validators';

export const calculateReceivableDueDate = (creditDays: string | number | null | undefined): string => {
  const days = parseInt(String(creditDays ?? ''), 10);
  if (!days || days <= 0) {
    return '';
  }
  const dueDate = new Date();
  dueDate.setDate(dueDate.getDate() + days);
  return dueDate.toISOString().slice(0, 10);
};

export const AddReceivableFormModel = (
  strings: any,
  options?: { salesManagementCorporateMode?: boolean },
): FormModel[] => {
  const salesManagementCorporateMode = options?.salesManagementCorporateMode ?? false;

  const corporateViewFields: FormModel[] = salesManagementCorporateMode
    ? [
        {
          label: strings.receivable_field_company,
          value: '',
          size: 'medium',
          type: 'text',
          typeValue: 'text',
          variant: 'outlined',
          placeholder: '',
          field: 'companyDisplay',
          validators: [],
          responsive: { xs: 12, sm: 6 },
          required: false,
          disabled: true,
        },
        {
          label: strings.receivable_field_branch,
          value: '',
          size: 'medium',
          type: 'text',
          typeValue: 'text',
          variant: 'outlined',
          placeholder: '',
          field: 'branchDisplay',
          validators: [],
          responsive: { xs: 12, sm: 6 },
          required: false,
          disabled: true,
        },
        {
          label: strings.receivable_field_contact,
          value: '',
          size: 'medium',
          type: 'text',
          typeValue: 'text',
          variant: 'outlined',
          placeholder: '',
          field: 'contactDisplay',
          validators: [],
          responsive: { xs: 12, sm: 6 },
          required: false,
          disabled: true,
        },
      ]
    : [
        {
          label: strings.receivable_field_companyName,
          value: '',
          size: 'medium',
          type: 'text',
          typeValue: 'text',
          variant: 'outlined',
          placeholder: '',
          field: 'companyName',
          validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateString, max: 255 }],
          responsive: { xs: 12, sm: 6 },
          required: true,
        },
      ];

  return [
  {
    label: strings.receivable_field_type,
    value: '',
    size: 'medium',
    type: 'drop-down',
    placeholder: '',
    field: 'type',
    validators: [{ check: Validators.validateMandatoryField }],
    responsive: { xs: 12, sm: 6 },
    required: true,
    options: [
      { value: 'BILL_TO_COMPANY', label: strings.receivable_type_billToCompany },
      { value: 'CITY_LEDGER', label: strings.receivable_type_cityLedger },
    ],
  },
  {
    label: strings.receivable_field_amount,
    value: '',
    size: 'medium',
    type: 'text',
    typeValue: 'number',
    variant: 'outlined',
    placeholder: '',
    field: 'amount',
    validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateFloat }],
    responsive: { xs: 12, sm: 6 },
    required: true,
  },
  ...corporateViewFields,
  {
    label: strings.receivable_field_gstNumber,
    value: '',
    size: 'medium',
    type: 'text',
    typeValue: 'text',
    variant: 'outlined',
    placeholder: '',
    field: 'gstNumber',
    validators: [{ check: Validators.validateString, max: 20 }],
    responsive: { xs: 12, sm: 6 },
    required: false,
  },
  {
    label: strings.receivable_field_creditDays,
    value: '',
    size: 'medium',
    type: 'text',
    typeValue: 'number',
    variant: 'outlined',
    placeholder: '',
    field: 'creditDays',
    validators: [{ check: Validators.validateMandatoryField }, { check: Validators.validateInt, min: 1 }],
    responsive: { xs: 12, sm: 6 },
    required: true,
  },
  {
    label: strings.receivable_field_dueDate,
    value: '',
    size: 'medium',
    type: 'date',
    placeholder: '',
    field: 'dueDate',
    validators: [],
    responsive: { xs: 12, sm: 6 },
    required: false,
    disabled: true,
  },
  {
    label: strings.receivable_field_remarks,
    value: '',
    size: 'medium',
    type: 'text',
    typeValue: 'text',
    variant: 'outlined',
    placeholder: '',
    field: 'remarks',
    validators: [{ check: Validators.validateString, max: 1000 }],
    responsive: { xs: 12 },
    required: false,
    multiline: true,
  },
  {
    label: strings.upload_document,
    value: '',
    type: 'upload',
    placeholder: '',
    field: 'attachment',
    validators: [],
    responsive: { xs: 12 },
    required: false,
    multiline: false,
  },
  ];
};
